import React from 'react';
import {SelectParent_SectionType} from "../../@const";
import ProjectSession from "../../../../model2/project/project-session";
import {SpaceProto} from "../../../../model2/space/space-proto";

type Props = {
    message  : string
}

export default function NotFound(props: Props) {

    // if (props.searchString) {
    //     return (
    //         <div className="flex-column-center-center h-100-percent">
    //             <div className="isvg-search-empty w-130 min-h-76"/>
    //             <div className="ui5-txt-no-accent-small p-t-20">No results found.</div>
    //         </div>
    //     )
    // }

    // let notFoundMessage: string = ""
    //
    // switch (props.currentSection) {
    //     case SelectParent_SectionType.PROJECTS: {
    //         notFoundMessage = "No results found."
    //     }
    //     break
    //
    //     case SelectParent_SectionType.PINNED: {
    //         notFoundMessage = "No pinned items found."
    //     }
    //     break
    //
    //     case SelectParent_SectionType.STARRED: {
    //         notFoundMessage = "No starred items found."
    //     }
    //     break
    //
    //     default: notFoundMessage = "No results found."
    // }

    return (
        <div className="flex-column-center-center h-100-percent">
            <div className="isvg-search-empty w-130 min-h-76"/>
            <div className="ui5-txt-no-accent-small p-t-20">{props.message}</div>
        </div>
    );
}
